import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme, { isSkyPointDashboard }) => ({
  greetingsParentClass: {
    // margin: "1rem",
    position: "relative",
    zIndex: 10,
    padding: "20px 30px",
  },
  welcomeHeading: {
    margin: "0",
    fontWeight: "400",
    lineHeight: "30px",
    fontFamily: "Inter",
    fontSize: 30,
    color: isSkyPointDashboard ? "#101828" : "#000",
  },
  smallText: {
    color: isSkyPointDashboard ? "#667085" : "#A3A3A3",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: 14,
  },
}));

export default useStyles;
